export default __webpack_public_path__ + "static/media/premiumGiftcards.4b96cb1f.png";